import { EventDispatcher } from "../../Utils/event-dispatcher";

export default class NotificationService extends EventDispatcher {
  public static EVENTS = {
    STATE_CHANGED: "state_changed",
    ACTION_BUTTON_CLICKED: "action_button_clicked",
  };
  private static instance: NotificationService;

  currentMessage: { title: string; message: string } = {
    title: "",
    message: "",
  };
  currentAction: string = "";

  private constructor() {
    super();
  }

  static getInstance(): NotificationService {
    if (!NotificationService.instance) {
      NotificationService.instance = new NotificationService();
    }
    return NotificationService.instance;
  }

  getCurrentMessage() {
    console.log("AgentService: current state message", this.currentMessage);
    return this.currentMessage;
  }

  setCurrentMessage(
    message: string,
    title: string,
    props: any,
    action: string
  ): {
    title: string;
    message: string;
  } {
    let msg = `${message}`;
    for (const key in props) {
      msg = msg.replace(`{{${key}}}`, props[key]);
    }
    console.log("AgentService: current state message", msg);
    this.currentMessage = {
      message: msg,
      title: title,
    };
    this.currentAction = action;
    this.dispatch(NotificationService.EVENTS.STATE_CHANGED, this.currentMessage);
    return this.currentMessage;
  }

  onActionButtonClicked(action: string) {
    this.dispatch(NotificationService.EVENTS.ACTION_BUTTON_CLICKED, action);
  }
}

